import React from 'react'
import styled from 'styled-components'

import Expander from '@talus-analytics/library.ui.expander'
import { FilterProps } from './FilterBar'

import useFilterOptions from 'dataHooks/useFilterOptions'

import FilterControl from './FilterControl'
import getFilters from './getFilters'
import device from 'utilities/device'

const FilterContainer = styled.section`
  /* display: flex; */
  /* justify-content: stretch; */
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); */
  grid-template-columns: repeat(5, 1fr);
  @media (max-width: 1220px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media ${device.laptop} {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
  gap: 15px;
  margin-top: 1rem;
`

const FilterSection: React.FC<FilterProps> = ({
  exploreState,
  setExploreState,
}) => {
  const filterOptions = useFilterOptions()
  const { coreFilters, moreFilters } = getFilters(filterOptions)

  return (
    <>
      <FilterContainer style={{ marginTop: '2.5rem' }}>
        {coreFilters.map(({ filterName, distinct }) => (
          <FilterControl
            key={filterName}
            {...{
              name: filterName,
              options: distinct,
              exploreState,
              setExploreState,
            }}
          />
        ))}
      </FilterContainer>
      <Expander open={exploreState.moreFilters}>
        <FilterContainer>
          {moreFilters.map(({ filterName, distinct }) => (
            <FilterControl
              key={filterName}
              {...{
                name: filterName,
                options: distinct,
                exploreState,
                setExploreState,
              }}
            />
          ))}
        </FilterContainer>
      </Expander>
    </>
  )
}

export default FilterSection
